import AboutArticleLeftItem from '../components/items/AboutArticleLeftItem'
import AboutArticleRightItem from '../components/items/AboutArticleRightItem'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import peopleWorking from '../people/Rectangle53.png'
import peopleWorking2 from '../people/Rectangle55.png'
import womanUsingPhone from '../people/Rectangle 54.png'
import investorsSmiling from '../people/Rectangle 60.png'
import AppContext from '../context/AppContext'
import Contact from './Contact'
import '../css/About.css'
import { motion } from 'framer-motion'
import { useContext } from 'react'

function About() {
    const { blur, openForm } = useContext(AppContext)

  return (
    <>
    <motion.main 
        id='about'
        initial={{width: 0}}
        animate={{width: '100%'}}
        exit={{x: window.innerWidth, transition: { duration: 0.1 }}}
    >   
        <ToastContainer/>
        <div className={blur ? 'blur' : ''}>
            <AboutArticleLeftItem 
                pill_text="About"
                article_heading="Reimagining healthcare"
                article_text={["At MedBolt AI Solutions Ltd, we are trailblazers in reimagining the future of healthcare. Our journey is driven by a dual commitment – to empower healthcare providers with cutting-edge technology and to offer individuals a personalized healthcare experience like never before.", "At MedBolt AI Solutions Ltd, we are trailblazers in reimagining the future of healthcare. Our journey is driven by a dual commitment – to empower healthcare providers with cutting-edge technology and to offer individuals a personalized healthcare experience like never before"]}
                article_img={peopleWorking}
                img_alt_text="Team mates working at an office"
            />
            <AboutArticleRightItem
                pill_text="Mission"
                article_heading="Our Mission"
                article_text={["Our mission at MedBolt is twofold.", "We are committed to equipping healthcare providers with state-of-the-art technology that revolutionizes medical data management, enhances efficiency, and elevates patient care. Simultaneously, we are dedicated to offering individuals a futuristic healthcare journey that is tailored, insightful, and empowering.", "By harnessing the power of artificial intelligence and data analytics, we are striving to create a healthcare ecosystem where technology works seamlessly with human interactions, providing unparalleled experiences for both healthcare professionals and patients."]}
                article_img={womanUsingPhone}
                img_alt_text="a woman using her phone for facial biometrics"
                background="transparent"
            />
            <AboutArticleLeftItem
                pill_text="Vision"
                article_heading="Our Vision"
                article_text={["Our vision transcends conventional boundaries. We foresee a healthcare landscape where technological innovation and human-centered care harmoniously coexist.", "Our aspiration is to redefine healthcare practices by offering individuals personalized and futuristic healthcare experiences that have never been witnessed before. Through our pioneering platforms, we aim to empower individuals to take charge of their health journeys, while also equipping healthcare providers with tools that optimize workflows, improve decision-making, and ultimately lead to healthier communities. Our vision encompasses a holistic transformation of healthcare, catalyzed by innovation, compassion, and excellence."]}
                article_img={peopleWorking2}
                img_alt_text="team working together with plants behind them"
            />
            <article className="article_right invest">
                <div>
                    <img src={investorsSmiling} alt="men smiling while looking at a laptop" />
                    <button className="trynow" onClick={openForm}>Contact us</button>
                </div>
                <div>
                    <h1>Interested in being an investor?</h1>
                    <p className="article_text">Medbolt is interested in buidling a world where healthcare is easier and safer for people. Does our mission and vision align with yours? Come join us impact and change lives.</p>
                    <button className="trynow" onClick={openForm}>Contact us</button>
                </div>
            </article>
        </div>
        <Contact/>
    </motion.main>
    </>
  )
}

export default About